import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import { LanguageProvider } from './context/LanguageContext';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <LanguageProvider>
      <App />
    </LanguageProvider>
  );
} else {
  console.error("ルート要素が見つかりません。");
}
